// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gP-z","twoColumnImage":"hP-z"};